import { AdditionalInsured } from './additional-insured.model';
import { BasicModel } from './basic.model';
import { RiskLocation } from './risk-location.model'
import { VehicleAccessory } from './vehicle-accessory.model'

export class Vehicle extends BasicModel<Vehicle> {
    vehiclePublicId?: string;
    licensePlate?: string;
    licensePlateInProcess?: boolean;
    engineNumber?: string;
    vin?: string;
    statedAmount?: number;
    infoautoCode?: number;
    vehicleMake?: string;
    vehicleMakeCode?: number;
    vehicleModel?: string;
    vehicleModelCode?: number;
    vehicleNumber?: string;
    vehicleVersion?: string;
    vehicleVersionCode?: number;
    vehicleYear?: string | number;
    vehicleCategoryCode?: string;
    accessories?: VehicleAccessory[];
    riskLocation?: RiskLocation;
    automaticAdjustmentCode?: string;
    additionalInsured?: AdditionalInsured[];
    lienHolder?: AdditionalInsured;
    infoAutoCode?: number;
    deductibleValueCodeIdentifier?: string;
    deductibleValueDescription?: string;
    productOffering?: {code: string, description: string };
    franchiseTypePublicId?: string;
}
